<div class="card min-w-[320px] max-w-[480px]">
    <p>Un administrador de Luxoro ha revocado tu accesio a la plataforma. Si crees que se trata de un error, por favor contacta con tu superior directo.</p>
    <div class="flex mt-8 justify-end">
        <p-button routerLink="/" label="Volver al inicio"></p-button>
    </div>
</div>